"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldFromName = fieldFromName;
const schema_1 = require("../schema");
/**
 *
 * @param name - what the user entered, i.e. name:Ryan --> name
 * @param options - the application that the user is searching in
 * @returns the field that the user is searching for
 */
function fieldFromName(name, options) {
    const searchableAttributes = [];
    //  now we can loop through all schemas and find the one that matches the name
    Object.keys(schema_1.SearchSchema)
        //  map each key to the schema
        .map((key) => {
        return schema_1.SearchSchema[key];
    })
        //  filter out the schemas that don't match the application
        .filter((schema) => {
        return schema.applications.includes(options.application);
    })
        //  loop through each schema and add the searchable attributes to the list if they have a shortName
        .forEach((schema) => {
        schema.searchableAttributes.forEach((attribute) => {
            if (attribute.shortName) {
                searchableAttributes.push({
                    entity: schema.name,
                    field: attribute.field,
                    alias: attribute.alias,
                    shortName: attribute.shortName,
                });
            }
        });
    });
    // now loop through the searchable attributes and find the one that matches the short name and map that to the field
    return searchableAttributes
        .filter((attribute) => attribute.shortName.toLowerCase() === name.toLowerCase())
        .map((attribute) => {
        return {
            entity: attribute.entity,
            field: attribute.field,
        };
    });
}
//# sourceMappingURL=field-from-name.js.map